export default __webpack_public_path__ + "locales/hy-AM/SharingPanel.json?hash=30d0f520aecf2b1a732d7dd54d905eab";